// project import
import dashboard from './dashboard';
import metrics from './metrics';
import onDemandDonations from './on-demand-donations';
import routineDonations from './routine-donations';
import marketplace from './marketplace';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
    items: [dashboard, metrics, marketplace, onDemandDonations, routineDonations]
};

export default menuItems;
